














import Vue from 'vue';
import camelcase from 'lodash.camelcase';

export default Vue.extend({
	props: ['item'],
	computed: {
		categoryName() {
			return camelcase(this.item.category);
		},
	},
	methods: {
		renderCategoryName(categoryName: string) {
			const key = `nodeCreator.categoryNames.${categoryName}`;

			return this.$locale.exists(key) ? this.$locale.baseText(key) : categoryName;
		},
	},
});
